import { render } from "./AtsiriEatScheduler.vue?vue&type=template&id=2864f924&scoped=true"
import script from "./AtsiriEatScheduler.vue?vue&type=script&lang=js"
export * from "./AtsiriEatScheduler.vue?vue&type=script&lang=js"

import "./AtsiriEatScheduler.vue?vue&type=style&index=0&id=2864f924&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenz\\atsiriBookingApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2864f924"]])

export default __exports__